// Identity and authorization come from the server. A seat/name never grants account ownership.
export function seatOptions(plan) {
  const c=plan && (plan.config || plan.originalConfig); if(!c)return []
  const items=[],role=(key,count)=>{for(let n=0;n<Number(count||0);n++)items.push({key:n?key+'_'+(n+1):key,label:n?key+' '+(n+1):key})}
  role('DRUMMER',c.drummerCount)
  for(let r=1;r<=Math.min(200,Number(c.rows)||0);r++)for(let n=1;n<=Number(c.perRow||1);n++)items.push({key:'P'+r+'-'+n,label:r+' · '+n})
  role('STEERER',c.steererCount)
  if(c.substituteMode!=='NONE')items.push({key:'SUBSTITUTE',label:'SUBSTITUTE'})
  return items
}
export function adminSeatPayload(plan,form) {
  if(!plan || !plan.canManage || plan.originalRegistrationId)throw new Error('seatForbidden')
  const reason=String(form.reason||'').trim();if(!reason || reason.length>500)throw new Error('seatReasonRequired')
  const action=plan.configured?form.action:'CONFIGURE'
  const data={entryId:plan.entryId,roundId:plan.roundId,version:plan.version,action,reason}
  if(action==='CONFIGURE') {if(!plan.originalConfig)throw new Error('seatConfigMissing');return {...data,config:plan.originalConfig}}
  if(!['ADD_MANUAL','MOVE','REJECT','CONFIRM'].includes(action))throw new Error('seatInvalid')
  const intent=(plan.intents||[]).find(i=>i.id===form.intentId)
  if(action!=='ADD_MANUAL' && (!intent || !['PENDING','CONFIRMED'].includes(intent.status)))throw new Error('seatPersonRequired')
  if(action==='ADD_MANUAL' || action==='MOVE') {
    if(!seatOptions(plan).some(s=>s.key===form.seat))throw new Error('seatPositionRequired')
    data.seat=form.seat
  }
  if(action==='ADD_MANUAL') {
    if(!String(form.displayName||'').trim())throw new Error('seatPersonRequired')
    data.displayName=form.displayName.trim();data.publicDisplay=!!form.publicDisplay
  } else data.intentId=intent.id
  if(action==='MOVE' && form.displacedSeat)data.displacedSeat=form.displacedSeat
  if(action==='CONFIRM') {
    if(intent.status!=='PENDING')throw new Error('seatInvalid')
    const occupant=intent.seat==='SUBSTITUTE'?null:(plan.intents||[]).find(i=>i.status==='CONFIRMED'&&i.seat===intent.seat&&intent.currentSeat!==intent.seat)
    data.resolution=occupant?form.resolution:'MOVE'
    if(occupant && !['SWAP','LINK','REPLACE'].includes(data.resolution))throw new Error('seatResolutionRequired')
    if(data.resolution==='REPLACE') {if(!form.displacedSeat)throw new Error('seatPositionRequired');data.displacedSeat=form.displacedSeat}
  }
  return data
}
